'use strict';

var createTable = require('../createTable');

/**
 * Insert a new table
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} columns
 * @param {Number} rows
 * @return {Slate.Transform}
 */
function insertTable(opts, transform) {
    var columns = arguments.length <= 2 || arguments[2] === undefined ? 2 : arguments[2];
    var rows = arguments.length <= 3 || arguments[3] === undefined ? 2 : arguments[3];
    var state = transform.state;
    var startBlock = state.startBlock;

    // Get text of current block

    var currentText = startBlock.text;

    // Create the table node
    var table = createTable(opts, columns, rows, function (x, y) {
        if (x == 0 && y == 0) return currentText;else return '';
    });

    return transform.insertBlock(table);
}

module.exports = insertTable;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-table/dist/transforms/insertTable.js
// module id = 687
// module chunks = 0